module.exports = __webpack_public_path__ + "img/PressKit.aa9a6817.webp";